import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import ManualMachineInstallingImage from 'assets/machines/manual-machine-installing.png'
import FullSemiAutomaticMachineInstallingImage from 'assets/machines/manual-machine-installing.png'
import FullAutomaticMachineInstallingImage from 'assets/machines/manual-machine-installing.png'
import MachineInstallingQuarters from 'components/Machines/MachineInstallingQuarters'
import { MACHINE_TYPES } from 'constants/machines'

function MachineInstalling({ from, to, type }) {
  const machine = useMemo(() => {
    switch (type) {
      case MACHINE_TYPES.manual_machine:
        return ManualMachineInstallingImage
      case MACHINE_TYPES.full_semi_automatic_machine:
        return FullSemiAutomaticMachineInstallingImage
      case MACHINE_TYPES.full_automatic_machine:
        return FullAutomaticMachineInstallingImage
      default:
        return ManualMachineInstallingImage
    }
  }, [type])

  return (
    <div className="machine-installing plant__machine">
      <img className="machine-installing__img" src={machine} alt="Installing machine" />
      <div className="machine-installing__time">
        <MachineInstallingQuarters from={from} to={to} />
      </div>
    </div>
  )
}

MachineInstalling.propTypes = {
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
}

export default memo(MachineInstalling)
